import * as React from "react";
import * as ReactDOM from "react-dom";
import { $$ } from '../dom';
import { Gallery } from "./components/Gallery";
import { Data } from "./types";

const IMAGE_GALLERY_SELECTOR = '.js-image-gallery';
const IMAGE_GALLERY_ITEM_SELECTOR = '.js-image-gallery-item';
export function ImageGallery(): void {
    const galleries = $$(IMAGE_GALLERY_SELECTOR);
    galleries.forEach(gallery => {
        const images = $$(IMAGE_GALLERY_ITEM_SELECTOR,gallery);
        const galleryImages :Array<Data.Image> = images.map((image, index) => {
            return {
                imageUrl: image.getAttribute('data-image-url') ?? '',
                imageAlt: image.getAttribute('data-image-alt') ?? '',
                imageIndex: index,
                caption: image.getAttribute('data-image-caption') ?? '',
                credits: image.getAttribute('data-image-credits') ?? '',
                position: {
                    x: image.getAttribute('data-image-position-x') ?? '50%',
                    y: image.getAttribute('data-image-position-y') ?? '50%'
                }
            };
        });
        const columns = gallery.getAttribute('data-columns') ?? '3';
        ReactDOM.render(
            <Gallery galleryImages={galleryImages} columns={columns}/>,
            gallery,
        );
    })
}
